<section id="see-how-it-works" class="demo-video-section py-5">
  <div class="container">
    <div class="row align-items-center g-5">
      <div class="col-lg-5">
        <div class="demo-copy">
          <p class="eyebrow">Product walkthrough</p>
          <h2 class="demo-title">See how MemberTrace works in practice</h2>
          <p class="demo-subtitle">
            Watch how MemberTrace brings memberships, events, payments, directories, and reporting into one connected workflow.
          </p>

          <ul class="demo-points">
            <li *ngFor="let point of demoBulletPoints">{{ point }}</li>
          </ul>

          <button
            mat-stroked-button
            color="primary"
            routerLink="/contact"
            [queryParams]="{ inquiryType: 'demo' }">
            Book a walkthrough
          </button>
        </div>
      </div>

      <div class="col-lg-7">
        <div class="video-container">
          <div class="video-placeholder" [class.playing]="isPlaying">
            <div class="video-overlay" *ngIf="!isPlaying">
              <button
                mat-fab
                color="accent"
                class="play-button"
                (click)="playVideo()"
                aria-label="Play demo video">
                <mat-icon>play_arrow</mat-icon>
              </button>
            </div>
            <video
              #videoPlayer
              class="demo-video"
              [src]="videoSrc"
              [poster]="posterSrc"
              preload="none"
              [attr.controls]="isPlaying ? true : null"
              (play)="isPlaying = true; videoLoaded = true"
              (pause)="isPlaying = false"
              (ended)="isPlaying = false">
              Your browser does not support the video tag.
            </video>
            <div class="video-thumbnail" *ngIf="!videoLoaded && isPlaying">
              <div class="fallback-thumbnail">
                <div class="thumbnail-content">
                  <mat-icon class="thumbnail-icon">video_library</mat-icon>
                  <span class="thumbnail-text">Demo Video</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="video-description mt-4">
          <p class="description-text">
            A quick look at how MemberTrace handles memberships, events, payments, and reporting in one system.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

